require('@readcube/item-manager');

const $                         = require('jquery');
const BasicModal                = require('../ctrl/basic_modal');
const evtout                    = require('../evtout');

class ManageItem {
  constructor({ item, syncApi }) {
    this._item = item;
    this._syncApi = syncApi;
    this._content = $('<div class="organize-item"></div>');

    const modal = this._modal = BasicModal({
      content: this._content,
      title: 'Toggle in Libraries / Lists',
      buttons: [
        {
          text: 'Save',
          primary: true,
          handler: function() {
            if (this.disabled) return;
            modal.save.apply(this);
          }
        },
        {
          text: 'Close',
          handler: function () {
            if (this.disabled) return;
            modal.close.apply(this);
          }
        }
      ]
    });
  }

  async _render() {
    const api = this._syncApi;
    const extIds = this._item?.ext_ids;
    const collectionId = this._item?.collection_id
    const itemId = this._item?.id;
    const container = this._content;

    const anchor = { collectionId, itemId, locked: true };
    const manager = $('<item-manager></item-manager>').appendTo(container)[0];
    manager.configure({ extIds, api, anchor });

    await manager.update({ collectionId, itemId });

    this._modal.save = async function() {
      try {
        this.disabled = true;
        const results = await manager.save();
        if (results.length) {
          await manager.update({ collectionId, itemId });
        }
      } catch (error) {
        console.error(error);
        console.error(manager.errors);
      } finally {
        this.disabled = false;
      }
    };

    manager.evtout.on('open-in-library', (e, { collectionId, listId, itemId }) => {
      evtout.trigger('open-in-library', [{
        collection_id: collectionId,
        list_id: listId,
        id: itemId
      }]);
    });
  }

  _toogleBusy(busy) {
    busy ?
      this._content.prepend(`
        <div class="loading-tree">
          <div class="loader-inner ball-pulse">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      `) :
      this._content.find('.loading-tree').remove();
  }

  open() {
    this._content.empty();
    this._toogleBusy(true);
    this._render().catch(error => {
      console.error(error);
      this._content.empty().append(`
        <h4>Whoops! Failed to fetch library data.</h4>
        <p>
          Please check your internet connection and make sure you are signed in,<br/>
          if the problem persists contact our <a href="mailto:support@readcube.com">support</a>.
        </p>
      `)
    }).finally(() => {
      this._toogleBusy(false);
    });
    return this._modal.open();
  }

  close() {
    this._content.empty();
    return this._modal.close();
  }
}

module.exports = ManageItem;
